export default "__VITE_ASSET__BsEpm3y$__"